/**
 * A single assistant round spending longer than this inside `thinking` blocks
 * is treated as pathological. Lives in `@orn/global` so the backend alert
 * (Sentry warning at persist time) and the MOPS transcript viewer's visual
 * flag read the exact same bar — tuning it moves both at once, so the "Sentry
 * said slow but the viewer doesn't show it" drift can't happen.
 */
export const THINKING_WARN_THRESHOLD_MS = 60_000;
